import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import Collapse from "../../components/atoms/colapso";
import Footer from "../../components/organisms/footer";
import NavBar from "../../components/organisms/navbar";
import { FaMapMarkerAlt } from 'react-icons/fa';
import {
  Container,
  Content,
  H3,
  H5,
  Location,
  P,
  QRCodeImg,
  Span,
  Title,
  TournamentActions,
  TournamentBanner,
  TournamentContainer,
  TournamentContainerBanner,
  TournamentContent,
  TournamentDescription,
  TournamentEnrollmentLink,
  TournamentEnrollmentLinkEndpage,
  TournamentLink,
  EditalContainer,
  EditalContent,
  EditalTitle
} from "./styles";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../services/api";
import Swal from "sweetalert2";
import tabelaPeso from "../../assets/images/tournaments/ii-copa-bushido-de-jiu-jitsu-2026/tabela-ii-copa-bushido-de-jiu-jitsu-2026.jpeg";

//Patrocinio
import torneio from "../../assets/images/sponsors/torneio-facil.png";
import logoParana from "../../assets/images/sponsors/parana.png";
import goldStar from "../../assets/images/sponsors/gold-star-eventos.jpeg";
import goldStarFight from "../../assets/images/sponsors/gold-star.jpeg";
import institutoAlfa from "../../assets/images/sponsors/instituto-alfa.jpeg";

//Apoio
import { SponsorContainer, SponsorList } from "src/components/atoms/sponsor-area/styles";
import SponsorButton from "src/components/atoms/sponsor-area";
import useAuthenticate from "../../hooks/useAuthenticate";

const sponsors = [
  // { img: logoParana, url: "" },
  // { img: goldStar, url: "" },
  // { img: goldStarFight, url: "" },
  // { img: institutoAlfa, url: "" },
  { img: torneio, url: "" },
];

const support = [
  { img: torneio, url: "http://www.torneiofacil.com" },
];

const cacheBuster = `?cacheBuster=${new Date().getTime()}`
const dataEvento = "12 de abril de 2026"
const horaEvento = "8:30h da manhã"
const tituloEvento = "Copa Bushido de Jiu Jitsu Gi 2026"
const localEvento = "Parque do Japão"
const endereçoEvento = "R. Tulípa, 987 - Jardim Industrial, Maringá - PR, CEP 87065-320"
const dataDeEncerramentoIncricao = "10/ABR/2026"
const horaDeEncerramentoIncricao = "23h:59"

const dataDeEncerramentoCorrecao = "10/ABR/2026"
const horaDeEncerramentoCorrecao = "23h:59min"

const dataDeEncerramentoInscricaoLoteUnico = "10/ABR/2026"
const dataDeEncerramentoAbsolutoLoteUnico = "10/ABR/2026"

//Valores LOTE 1
const valorinscricaoCategoriaLoteUnico = "160,00 (cento e sessenta reais)"
const valorinscricaoAbsolutoLoteUnico  = "70,00 (setenta reais)"

const dataDeDivulgacaoChaves = "11/ABR/2026"
const horaDeDivulgacaoChaves = "23h:59min"

const instituicaoBancaria = ""
const tipoDeChavePix = ""
const ChavePix = ""
const BeneficiarioDaChavePix = ""

const dataDeDivulgacaoCronograma = " "
const horaDeDivulgacaoCCronograma = " "

const contatoWhatsApp = "+55 44 99909-6269 - Rui"
const contatoWhatsAppTorneio = "+55 (11) 94456-3515"

const slugGI = "ii-copa-bushido-de-jiu-jitsu-maringa-pr-gi";
const slugNOGI = "ii-copa-bushido-de-jiu-jitsu-maringa-pr-nogi";
const rotaInscriçaoGi = `/enrollment/ii-copa-bushido-de-jiu-jitsu-maringa-pr-nogi`;
const rotaChecagemGi = "/check/ii-copa-bushido-de-jiu-jitsu-maringa-pr-gi/search";
const rotaChecagemNogi = "/check/ii-copa-bushido-de-jiu-jitsu-maringa-pr-nogi/search";
const rotaChavesGi = "/tournament/keys/ii-copa-bushido-de-jiu-jitsu-maringa-pr-gi"
const rotaChavesNogi = "/tournament/keys/ii-copa-bushido-de-jiu-jitsu-maringa-pr-nogi"


const IiCopaBushidoDeJiuJitsu2026: React.FC = () => {
  const { authenticated, getToken } = useAuthenticate();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleToSubscriptionPage = async () => {

    if (!authenticated) {
      Swal.fire({
        title: 'Você precisa estar autenticado',
        text: 'Deseja fazer login para se inscrever no evento?',
        icon: 'info',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Fazer login',
        focusConfirm: false,
        cancelButtonText: 'Agora não'
      }).then((action) => {
        if (action.isConfirmed) navigate('/login')
      });
      return;
    }

    const response = await api.get(
      `/tournaments/info/${slugGI}`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );

    if (response.data.canSubscribe === false) {
      Swal.fire({
        title: 'Atenção!',
        text: 'Período de inscrição encerrado!',
        icon: 'error',
      });
      toast.error('Período de inscrição encerrado!');
      return;
    }

    navigate(`/enrollment/${slugGI}`)

  }
  return (
    <>
      <NavBar />

      <Container>
        <TournamentContainer
          image={require("../../assets/images/tournaments/ii-copa-bushido-de-jiu-jitsu-2026/ii-copa-bushido-de-jiu-jitsu-2026-home.jpeg")}
        >
          <TournamentContainerBanner>
            <TournamentBanner
              image={require("../../assets/images/tournaments/ii-copa-bushido-de-jiu-jitsu-2026/ii-copa-bushido-de-jiu-jitsu-2026-tournament.jpeg")}
              imageMobile={require("../../assets/images/tournaments/ii-copa-bushido-de-jiu-jitsu-2026/ii-copa-bushido-de-jiu-jitsu-2026-home.jpeg")}
            />
          </TournamentContainerBanner>
        </TournamentContainer>
        <TournamentContent>
          <Content>
            <Title>{tituloEvento}</Title>
            <Location>
              <Span>Data: {dataEvento}</Span>
              <Span>Início: {horaEvento}</Span>
              <Span>Local: {localEvento}</Span>
              <Span>Endereço: {endereçoEvento}</Span>
              <Span>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                  <FaMapMarkerAlt style={{ marginRight: '8px', color: "red" }} />
                  <a
                    target={"blank"}
                    style={{ color: "#000", textDecoration: "none", fontWeight: "bold" }}
                    href="https://maps.app.goo.gl/Byu3THny18AePCtd8"
                  >
                    Ver no Google Maps
                  </a>
                </div>
              </Span>
            </Location>
            <P></P>
            <br />

          </Content>
        </TournamentContent>
        <TournamentDescription>
          <TournamentActions>
            <Content>
              <h1 style={{ textAlign: "center" }}>PATROCINADORES</h1>
              <SponsorContainer>
                <SponsorList>
                  {sponsors && sponsors.map((buttons: any, index: number) => (
                    <SponsorButton
                      key={index}
                      img={buttons.img}
                      url={buttons.url}
                      hasError={false}
                      error="Este campo é obrigatório"
                      target="_blank"
                    />
                  ))}
                </SponsorList>
              </SponsorContainer>
              <h1 style={{ textAlign: "center" }}>APOIO</h1>
              <SponsorContainer>
                <SponsorList>
                  {support &&
                    support.map((buttons: any) => (
                      <SponsorButton
                        img={buttons.img}
                        url={buttons.url}
                        hasError={false}
                        error="Este campo é obrigatório"
                      />
                    ))}
                </SponsorList>
              </SponsorContainer>
            </Content>

            <Content style={{
              marginTop: '32px'
            }}>

              <EditalContainer>
                <EditalTitle>EDITAL {tituloEvento.toLocaleUpperCase()}</EditalTitle>
                <EditalContent>
                  <Span>
                    O {tituloEvento} é um evento que fomenta e incentiva a prática do jiu jitsu
                    na cidade de Maringá-PR e região. As lutas serão GI (com kimono),
                    o evento disponibilizará categorias para todas as idades e faixas, conforme as tabelas
                    de peso deste edital. Os competidores terão a oportunidade de testar suas habilidades
                    em um ambiente controlado e com acompanhamento de profissionais qualificados.
                  </Span>
                  <br />
                  <br />
                  <br />
                </EditalContent>

                <Collapse title="PROTOCOLO DE SEGURANÇA CONTRA COVID-19">
                  <P>
                    Devido a dinâmica da situação atual, estamos avaliando diariamente as
                    recomendações dos Órgãos de Saúde e este protocolo pode ser atualizado a
                    qualquer momento caso novas determinações sejam publicadas.
                  </P>
                  <P>
                    Caso o evento seja cancelado por força maior, todas as inscrições serão
                    automaticamente reembolsadas.
                  </P>
                  <P>
                    A organização não é responsável pelos demais custos dos participantes,
                    tais como transporte e hospedagem.
                  </P>
                  <P>
                    Diretrizes do ginásio: Para a segurança de todos, por favor verifique
                    sua temperatura antes de se dirigir ao evento.{" "}
                  </P>
                  <P>Caso haja qualquer sintoma, procure um médico.</P>{" "}
                  <P>
                    {" "}
                    Caso você se sinta indisposto ou esteve em contato com um paciente
                    diagnosticado com Covid-19, por favor fique em casa e procure seu
                    médico.
                  </P>
                </Collapse>
                <Collapse title="PREMIAÇÕES:  DINHEIRO💰 + TROFÉU🏆 + MEDALHAS🥇" >
                  <H3>Academias:</H3>
                  <P>1° lugar:🏆 Troféu </P>
                  <P>2° lugar:🏆 Troféu </P>
                  <P>3° lugar:🏆 Troféu </P>

                  <H3>Absoluto Masculino GI:</H3>
                  <H5>Adulto e Master Branca - (juntos) </H5>
                  <P>1° lugar: R$300,00 + Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Adulto e Master Azul - (juntos) </H5>
                  <P>1° lugar: R$350,00 + Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Adulto e Master Roxa - (juntos) </H5>
                  <P>1° lugar: R$400,00 + Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Adulto e Master 1 e 2 Marrom - (juntos) </H5>
                  <P>1° lugar: R$500,00 + Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Master 3,4,5 - Marrom </H5>
                  <P>1° lugar: R$500,00 + Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Master 1 e 2 - Preta  </H5>
                  <P>1° lugar: R$700,00 + Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Master 3,4,5 - Preta </H5>
                  <P>1° lugar: R$700,00 + Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <br />

                  <H3>Absoluto Feminino GI:</H3>
                  <H5>Adulto e Master Azul/Roxa e Marrom - (juntas) </H5>
                  <P>1° lugar: R$500,00 + Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <br />

                  <H3>Demais Categorias GI</H3>
                  <P>1° lugar: Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <br />
                  <h3>Inscrições para o absoluto serão realizadas diretamente pelo site www.torneiofacil.com.br</h3>
                  <p>OBS: Estas premiações só irão valer para os Absolutos que tiverem 05 (CINCO)
                    ou mais atletas inscritos.</p>
                  <p>
                  <p>
                    Obrigatório ter o mínimo de 5 atletas para ter o absoluto.
                  </p>
                    Mais informações sobre as inscrições para o absoluto está disponível
                    na seção INSCRIÇÕES, parágrafo Inscrição de Absoluto deste edital.
                  </p>
                  <br />
                </Collapse>

                <Collapse title="INSCRIÇÕES">
                  <Span>
                    As inscrições para o evento serão realizadas exclusivamente online, por
                    meio do site www.torneiofacil.com.br
                  </Span>
                  <P>
                    Durante o processo de inscrição, o atleta ou seu responsável legal
                    deverá selecionar corretamente a categoria referente idade que o atleta
                    completará no ano de 2026, bem como sua faixa e peso.
                  </P>
                  <P>
                    A idade de competição do atleta é a idade máxima que ele terá em 2026,
                    conforme regra da CBJJ.
                  </P>
                  <br />
                  <H3>Prazo de Inscrição</H3>
                  <P>
                    O prazo final para inscrições e pagamento será até  {dataDeEncerramentoIncricao}, às {""}
                    {horaDeEncerramentoIncricao}min.
                  </P>
                  <br />
                  <P>As inscrições que não forem pagas serão canceladas.</P>
                  <br />

                  <H3>Correção</H3>
                  <P>
                    A correção da inscrição poderá ser realizada somente após a confirmação
                    do pagamento.
                  </P>
                  <P>
                    Em caso de inscrição equivocada, o atleta ou professor responsável
                    poderá corrigir as informações no site www.torneiofacil.com.br,
                    acessando a opção Meu Perfil em seguida Minhas Inscrições.
                  </P>
                  <P>
                    A correção da inscrição ficará disponível até o encerramento das
                    inscrições {dataDeEncerramentoCorrecao} às {horaDeEncerramentoCorrecao}.
                  </P>
                  <P>
                    Após prazo para correção das inscrições, não serão aceitas modificações
                    nas inscrições.
                  </P>
                  <P>
                    Os atletas que se inscreverem incorretamente estarão sujeitos a
                    desclassificação <b>sem direito a reembolso.</b>
                  </P>
                  <br />
                  <H3>Prazo de Correção</H3>
                  <P>
                    A correção da inscrição fica disponível após a confirmação do pagamento
                    da mesma.
                  </P>
                  <P>
                    A correção da inscrição ficará disponível até o encerramento das
                    inscrições {dataDeEncerramentoCorrecao} as {horaDeEncerramentoCorrecao}.
                  </P>
                  <br />
                  <H3>Chaves</H3>
                  <P>
                    O sorteio e divulgação das chaves de lutas será em {dataDeDivulgacaoChaves} até às {horaDeDivulgacaoChaves}.
                  </P>
                  <br />
                  <H3>Inscrição de Absoluto</H3>
                  <P>Inscrições para o absoluto serão realizadas diretamente pelo site www.torneiofacil.com.br , valor R$70,
                    00
                  </P>
                  <P>
                    Somente atletas inscritos na categoria poderão se inscrever e participar
                    do absoluto.
                  </P>
                  <P>
                    Os atletas só poderão se inscrever no absoluto referente a categoria da
                    sua inscrição no torneio. Exceção apenas para os master que poderá se
                    inscrever como absoluto adulto.
                  </P>
                </Collapse>
                <Collapse title="PESSOAS COM DEFICIÊNCIA (PCD)">
                  <H3>
                    As pessoas com deficiência (PCD) devem informar, no momento da
                    inscrição, sua condição pelo WhatsApp. Caso contrário o atleta será
                    desclassificado sem direito a reembolso.
                  </H3>

                  <br />
                </Collapse>

                <Collapse title="VALOR DA INSCRIÇÃO">
                  <Span>
                    As inscrições serão em lote único:
                  </Span>
                  <H3>Lote Único até {dataDeEncerramentoInscricaoLoteUnico}</H3>
                  <P>Inscrição categoria Gi R$ {valorinscricaoCategoriaLoteUnico} </P>
                  <P>Inscrição categoria Absoluto R$ {valorinscricaoAbsolutoLoteUnico} </P>
                  <br />
                </Collapse>

                <Collapse title="PAGAMENTO">
                  <H3>
                    A baixa do pagamento será efetuada de forma automática.
                  </H3>
                  <H3>
                    É necessário completar todas as etapas até finalizar a operação de pagamento.
                  </H3>
                  <p />
                </Collapse>

                <Collapse title="REEMBOLSO DAS INSCRIÇÕES">
                  <H3>
                    Uma vez PAGA a inscrição, o atleta tem direito ao reembolso nas seguintes situações:
                  </H3>
                  <P>
                    1) Quando o evento é CANCELADO.
                  </P>
                  <P>
                    2) Quando ocorre alteração na DATA do evento.
                  </P>
                  <P>
                    3) Quando altera o LOCAL do evento com distância maior que 20km em relação ao anterior.
                  </P>
                  <P>
                    4) Quando há diminuição da premiação, somente para os atletas impactados.
                  </P>
                  <H3>
                    Obs: Para os 4 casos acima, o prazo máximo para solicitar reembolso será de até 5 dias (corridos)
                    após a divulgação do COMUNICADO no site www.torneiofacil.com.br ou DATA FIM da CHECAGEM GERAL ABERTA ( a data que ocorrer primeiro ).
                  </H3>
                  <P>
                    5) Quando o atleta se lesiona e tenha comprado a GARANTIA CAMPEÃ no ato da inscrição (desde que apresente um laudo médico
                    comprovando a lesão até SEGUNDA-FEIRA antecedente ao evento, através do Fale Conosco). Neste caso da garantia, o atleta
                    usufrui do reembolso de 80% do valor pago na inscrição.
                  </P>
                  <P>
                    Em caso de CALAMIDADE PÚBLICA, PANDEMIA, CATÁSTROFE NATURAL e DECRETOS GOVERNAMENTAIS, considerados motivo de FORÇA MAIOR,
                    o atleta NÃO TEM direito ao reembolso.
                  </P>
                  <P>
                    Para estes casos, a organização oferecerá alternativas para uso do crédito do atleta que não puder comparecer na nova data
                    do evento, ao invés do reembolso, desde que o atleta nos notifique pelo FALE CONOSCO até SEGUNDA-FEIRA antecedente ao evento).
                  </P>
                  <P>
                    Após os períodos predeterminados, o atleta perderá o direito a reembolso ou crédito.
                  </P>
                  <H3>
                    Além disso, o atleta NÃO tem direito a reembolso de valores quando:
                  </H3>
                  <P>
                    1) Está sozinho na chave de luta.
                  </P>
                  <P>
                    2) Se machuca antes do evento impossibilitando o atleta de participar do mesmo, sem ter adquirido a GARANTIA CAMPEÃ.
                  </P>
                  <P>
                    3) Desistência por qualquer motivo.
                  </P>
                </Collapse>

                <Collapse title="REGRAS">

                  <Span>
                    Todas as regras para o evento estão devidamente estipuladas e detalhadas neste edital.
                  </Span>
                  <Span>
                    Em casos de omissão de regras no presente edital, as normas a serem observadas serão aquelas estabelecidas pela Confederação
                    Brasileira de Jiu-Jitsu (CBJJ), em conformidade com as diretrizes da CBJJ/IBJJF.
                  </Span>
                  <Span>
                    A tabela de peso por categoria, que estabelece os limites de peso para cada categoria, encontra-se disponível no site oficial do evento,
                    acessível por meio do botão denominado "Tabela de Peso".
                  </Span>
                  <Span>
                    As lutas serão com GI (com kimonos de cores Oficiais pela cbjj branco,
                    azul e preto ) os kimonos devem estar limpos sem rasgos e sem odor .
                  </Span>
                  <Span>
                    Para categoria com 3 lutadores, o lutador que ficar sozinho no sorteio da chave estará automaticamente na final.
                    Em caso de WO de um atleta, os dois lutadores restantes na categoria disputarão a final.
                  </Span>
                  <Span>
                    A pesagem será realizada no dia do evento. O competidor deverá
                    apresentar documento oficial com foto no momento da pesagem.
                  </Span>
                  <Span>
                    A pesagem dos atletas serão realizadas antes do inicio da categoria.
                  </Span>
                  <Span>
                    Atletas que ultrapasarem o limite de peso da categoria que estiverem
                    inscritos serão automaticamente desclassificados e não poderão lutar o
                    Absoluto.
                  </Span>
                  <Span>
                    Afim de evitar chaves sem lutas o esquema de faixa usado
                    será o seguinte:
                  </Span>
                 <P> Branca; </P>
                 <P> Cinza e Amarela (juntas)</P>
                 <P> Laranja e Verde(juntas)</P>    
                 <P> Azul; </P>
                 <P> Roxa; </P>
                 <P> Marrom; </P>
                 <P> Preta. </P>
                  <Span> Será permitida a inscrição de atletas Juvenil na faixa Verde, porém
                    ele lutará como Juvenil faixa Azul.
                  </Span>
                  <Span>Será realizada apenas uma pesagem oficial por atleta.</Span>
                  <Span>
                    Teremos uma balança para pesagem livre (não oficial) para os atletas.
                  </Span>
                  <Span>Teremos duas balanças para pesagem oficial dos atletas.</Span>
                  <Span>
                    Atletas que lutaram em outros eventos com faixa superior não poderão
                    lutar com a faixa abaixo. Se descoberto, o competidor será eliminado do
                    torneio sem direito a reembolso.
                  </Span>
                  <br />
                  <H3>Pontuação por equipe</H3>
                  <H5>Categoria e Absoluto, todas as faixas</H5>
                  <P>1° lugar: 9 pontos</P>
                  <P>2° lugar: 3 pontos</P>
                  <P>3° lugar: 1 ponto</P>
                  <P>
                    A contagem dos pontos será realizada de forma geral contabilizando os
                    pontos de todas as faixas.
                  </P>
                  <P>Campeão direto não contam pontos, chaves com apenas um inscrito.</P>
                  <P>
                    Campeão por WO, devido a desistência do oponente, contará pontos desde
                    que na chave tenha mais de um inscrito.
                  </P>
                  <P>
                    Categorias com atletas somente da mesma academia não contam pontos
                    para a disputa por academias, para contar pontos é necessário ao menos um
                    atleta de outra academia para validar a chave.
                  </P>
                  <br />
                  <H3>Para o absoluto:</H3>
                  <P>
                    Não será permitido luta combinada.
                  </P>
                  <P>
                    Não será permitido fechamento dos finalistas.
                  </P>
                  <P>
                    Não será permitido o atleta deixar de fazer o combate, afim de beneficiar o outro atleta.
                  </P>
                  <P>
                    Caso aconteça alguns desses itens acima, a organização fica sem a obrigação de fazer a entrega da premiação citado nesse edital.
                  </P>
                  <br />
                  <P>
                    O que não estiver neste edital, será acatado o que estiver no livro de
                    regras da CBJJ.
                  </P>
                  <br />
                  <P>
                    <a
                      target={"blank"}
                      href="https://cbjj.com.br/books-videos"
                      style={{ color: "white" }}
                    >
                      <strong>LIVRO DE REGRAS DA CBJJ/IBJJF</strong>
                    </a>
                  </P>
                </Collapse>
                <Collapse title={"CRONOGRAMA" + dataDeDivulgacaoCronograma + " " + horaDeDivulgacaoCCronograma}>
                  (EM BREVE)
                  <Container>
                  </Container>
                </Collapse>
                <Collapse title="ENTRADA">
                  <P>
                    Liberada ao público.
                  </P>
                </Collapse>
                <Collapse title="CONTATO">
                  <P>Caso Precise falar com o responsável do evento, entre em contato por telefone ou WhatsApp.</P>
                  <a target={"blank"} href={`https://whatsa.me/554499096269/?t=Ol%C3%A1!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20na%20*II%20COPA%20BUSHIDO%20DE%20JIU%20JITSU%202026*`}
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsApp} </strong>
                    <FaWhatsapp />
                  </a>
                  <br />
                  <br />
                  <P>
                    Dúvidas sobre cadastro, inscrição, pagamento, correção, checagem ou
                    sugestão de melhorias entre em contato com a equipe do Torneio Fácil
                    por telefone ou WhatsApp.
                  </P>
                  <P>Melhor horário para atendimento das 18:00h as 23:59h.</P>
                  <a
                    target={"blank"}
                    href={`https://whatsa.me/5511944563515/?t=Olá%20Equipe%20Torneio%20Fácil!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20na%20II%20COPA%20BUSHIDO%20DE%20JIU%20JITSU%202026*`}
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsAppTorneio} </strong>
                    <FaWhatsapp />
                  </a>

                  <br />
                </Collapse>
              </EditalContainer>
            </Content>
            <br />
            <Content>
              <TournamentEnrollmentLinkEndpage to={""} onClick={() => handleToSubscriptionPage()}>
                Inscrição
              </TournamentEnrollmentLinkEndpage>

              <TournamentEnrollmentLinkEndpage to="/profile/subscription">
                Correção da Inscrição
              </TournamentEnrollmentLinkEndpage>

              <TournamentLink
                href={rotaChecagemGi}
              >
                Checagem
              </TournamentLink>
              {/* <TournamentLink
                href={rotaChecagemNogi}
              >
                Checagem NOGI
              </TournamentLink> */}

              <TournamentLink
                href={rotaChavesGi}
              >
                Chaves
              </TournamentLink>
              {/* <TournamentLink
                href={rotaChavesNogi}
              >
                Chaves NOGI
              </TournamentLink> */}

              <TournamentLink target="blank" href={tabelaPeso}>
                Tabela de pesos
              </TournamentLink>
            </Content>
          </TournamentActions>
        </TournamentDescription>
      </Container>
      <Footer />
    </>
  );
};

export default IiCopaBushidoDeJiuJitsu2026;
